<template>
  <div class="course-page" dir="rtl">
    <div class="container">
      <div class="header">
        <h1 class="page-title">الكورسات</h1>
      </div>

      <div class="search-section">
        <div class="search-fields">

          <div class="search-group">
            <label for="categoryFilter">التصنيف</label>
            <select
              id="categoryFilter"
              class="form-control"
              v-model.number="filters.categoryId"
              placeholder="اختر التصنيف"
            >
              <option :value="0">-- الكل --</option>
              <option v-for="cat in categoryList" :key="cat.id" :value="cat.id">
                {{ cat.name }}
              </option>
            </select>
          </div>

          <div class="search-group">
            <label for="universityFilter">الجامعة</label>
            <select
              id="universityFilter"
              class="form-control"
              v-model.number="filters.universityId"
              placeholder="اختر الجامعة"
            >
              <option :value="0">-- الكل --</option>
              <option
                v-for="uni in universityList"
                :key="uni.id"
                :value="uni.id"
              >
                {{ uni.name }}
              </option>
            </select>
          </div>

          <div class="search-group">
            <label for="academicLevelFilter">المستوى الأكاديمي</label>
            <select
              id="academicLevelFilter"
              class="form-control"
              v-model.number="filters.academicLevel"
              placeholder="اختر المستوى"
            >
              <option :value="0">-- الكل --</option>
              <option
                v-for="level in academicLevels"
                :key="level.value"
                :value="level.value"
              >
                {{ level.label }}
              </option>
            </select>
          </div>
          <button class="btn btn-search" @click="searchCourses">بحث</button>

          <button class="btn btn-add" @click="openModalForAdd">
            إضافة دورة جديدة
          </button>
        </div>
      </div>

      <div class="cards-grid">
        <div
          class="course-card"
          v-for="course in courses"
          :key="course.id"
          @click="openDetailModal(course.id)"
        >
          <img
            class="cover-photo"
            :src="course.coverPhoto || defaultCoverPhoto"
            alt="صورة الغلاف"
            @error="handleImageError"
          />

          <div class="card-content">
            <h3 class="course-title">{{ course.title }}</h3>
            <h3 class="course-title">التصنيف : {{ course.category ? course.category.name : "-" }}</h3>
            <h3 class="course-title">الجامعه : {{ course.university ?  course.university.name  : "-"}}</h3>
            <h3 class="course-title">
              المستوى الأكاديمي : {{ course.academicLevel }}
            </h3>
            <p class="course-description">
              {{
                course.description?.length > 80
                  ? course.description.slice(0, 80) + "..."
                  : course.description
              }}
            </p>
          </div>

          <div class="card-actions" @click.stop>
            <div class="actions-cell">
                  <button class="btn-action edit" @click="openModalForEdit(course)">
                    <span class="action-icon">✎</span>
                    تعديل
                  </button>
                  <button class="btn-action delete" @click="deleteCourse(course.id)">
                    <span class="action-icon">×</span>
                    حذف
                  </button>
                </div>

          </div>
        </div>
      </div>

      <div class="modal-overlay" v-if="showModal" @click.self="closeModal">
        <div class="modal-content form-modal">
          <h2 class="modal-title">
            {{ isEditMode ? "تعديل الدورة" : "إضافة دورة جديدة" }}
          </h2>
          <form
            @submit.prevent="handleSubmit"
            enctype="multipart/form-data"
            class="modal-form"
          >
            <div class="two-column-row">
              <div class="form-group">
                <label class="form-label">العنوان</label>
                <input
                  type="text"
                  v-model="form.title"
                  class="form-control"
                  placeholder="أدخل عنوان الدورة"
                  required
                />
              </div>

              <div class="form-group">
                <label class="form-label">النقاط</label>
                <input
                  type="number"
                  v-model.number="form.point"
                  class="form-control"
                  placeholder="عدد النقاط"
                  required
                />
              </div>
            </div>

            <div class="two-column-row">
              <div class="form-group">
                <label class="form-label">نوع الدورة</label>
                <!--   -->
                <select
                  v-model.number="form.courseType"
                  class="form-control"
                  required
                >
                  <option value="1">داخلي</option>
                  <option value="2">خارجي</option>
                </select>
              
              </div>

              <div class="form-group">
                <label class="form-label">المستوى الأكاديمي</label>
                <select
                  v-model.number="form.academicLevel"
                  class="form-control"
                  required
                >
                  <option
                    v-for="level in academicLevels"
                    :key="level.value"
                    :value="level.value"
                  >
                    {{ level.label }}
                  </option>
                </select>
              </div>
            </div>

            <div class="two-column-row">
              <div class="form-group">
                <label class="form-label">الجامعة</label>
                <select
                  v-model.number="form.universityId"
                  class="form-control"
                  required
                >
                  <option :value="0" disabled>-- اختر الجامعة --</option>
                  <option
                    v-for="uni in universityList"
                    :key="uni.id"
                    :value="uni.id"
                  >
                    {{ uni.name }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label class="form-label">التصنيف</label>
                <select
                  v-model.number="form.categoryId"
                  class="form-control"
                  required
                >
                  <option :value="0" disabled>-- اختر التصنيف --</option>
                  <option
                    v-for="cat in categoryList"
                    :key="cat.id"
                    :value="cat.id"
                  >
                    {{ cat.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">الوصف</label>
              <textarea
                v-model="form.description"
                class="form-control"
                rows="3"
                placeholder="أدخل وصف الدورة"
                required
              ></textarea>
            </div>

            <div class="form-group">
              <label class="form-label">صورة الغلاف</label>
              <input
                type="file"
                @change="handleFileChange"
                class="form-control"
                ref="coverPhotoInput"
                :required="!isEditMode"
              />
            </div>

            <div class="modal-actions">
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? "تحديث الدورة" : "إضافة الدورة" }}
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                @click="closeModal"
              >
                إغلاق
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        class="modal-overlay detail-overlay"
        v-if="showDetailModal"
        @click.self="closeDetailModal"
      >
        <div class="modal-content detail-modal">
          <h2 class="modal-title">تفاصيل الكورس</h2>
          <div class="detail-scrollable" v-if="detailCourse">
            <div class="detail-cover">
              <img
                :src="detailCourse.coverPhoto || defaultCoverPhoto"
                alt="غلاف الكورس"
                class="detail-cover-photo"
                @error="handleImageError"
              />
            </div>

            <div class="detail-content">
              <h3 class="detail-title">{{ detailCourse.title }}</h3>
              <p><strong>النقاط:</strong> {{ detailCourse.point }}</p>
              <p>
                <strong>المستوى الأكاديمي:</strong>
                {{ academicLevelText(detailCourse.academicLevel) }}
              </p>
              <p>
                <strong>الجامعة:</strong>
                {{ detailCourse.university?.name }}
              </p>
              <p>
                <strong>التصنيف:</strong>
                {{ detailCourse.category?.name }}
              </p>
              <p class="detail-description">
                <strong>الوصف:</strong>
                {{ detailCourse.description }}
              </p>

              <div
                v-if="detailCourse.videos && detailCourse.videos.length"
                class="videos-section"
              >
                <h4>الفيديوهات:</h4>
                <ul>
                  <li v-for="vid in detailCourse.videos" :key="vid.id">
                    <p>{{ vid.title }}</p>
                    <video
                      :src="vid.videoFullUrl"
                      controls
                      width="300"
                      style="display: block; margin-bottom: 10px"
                    ></video>
                    <p>{{ vid.description }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-else>
            <p>جاري تحميل التفاصيل...</p>
          </div>

          <div class="modal-actions">
            <button class="btn btn-secondary" @click="closeDetailModal">
              إغلاق
            </button>
          </div>
        </div>
      </div>

      <!-- قسم الترقيم (CustomPagination) -->
      <custom-pagination
        :currentPage="pageNumber"
        :totalPages="totalPages"
        @page-changed="handlePageChange"
      />
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";
import CustomPagination from "@/components/CustomPagination.vue";

export default {
  name: "CoursePage",
  components: { CustomPagination },
  data() {
    return {
      // قائمة الدورات المعروضة
      courses: [],
      // الترقيم
      pageNumber: 1,
      pageSize: 8,
      totalPages: 1,

      // مودال الإضافة/التعديل
      showModal: false,
      isEditMode: false,

      // مودال التفاصيل
      showDetailModal: false,
      detailCourse: null, // بيانات الكورس التفصيلية

      // صورة افتراضية
      defaultCoverPhoto: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='150'%3E%3Crect width='300' height='150' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-family='Arial' font-size='14'%3Eلا توجد صورة%3C/text%3E%3C/svg%3E",

      // نموذج الدورة
      form: {
        id: null,
        title: "",
        description: "",
        point: 0,
        courseType: 1,
        universityId: 0,
        coverPhoto: null,
        coverPhotoUrl: "",
        academicLevel: 1,
        categoryId: 0,
      },

      // فلاتر البحث
      filters: {
        categoryId: "",
        universityId: "",
        academicLevel: "",
      },

      // قوائم (التصنيفات + الجامعات + المستويات)
      categoryList: [],
      universityList: [],
      academicLevels: [
        { value: 1, label: "الأول" },
        { value: 2, label: "الثاني" },
        { value: 3, label: "الثالث" },
        { value: 4, label: "الرابع" },
        { value: 5, label: "الخامس" },
        { value: 6, label: "السادس" },
      ],
    };
  },
  methods: {
    // *** API لعرض التصنيفات والجامعات
    async fetchCategoriesAndUniversities() {
      try {
        const catRes = await apiClient.get("/api/Categories/GetAllCategories");
        this.categoryList = catRes.data.items || [];

        const uniRes = await apiClient.get(
          "/api/Universities/GetAllUniversities"
        );
        this.universityList = uniRes.data.items || [];
      } catch (error) {
        console.error("خطأ في جلب التصنيفات/الجامعات:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب التصنيفات أو الجامعات",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    // *** API لعرض الدورات بالفلترة
    async getCoursesByFilter() {
      try {
        const response = await apiClient.get("/api/Course/GetAllCourses", {
          params: {
            CategoryId: this.filters.categoryId,
            UniversityId: this.filters.universityId,
            AcademicLevel: this.filters.academicLevel,
            PageNumber: this.pageNumber,
            PageSize: this.pageSize,
          },
        });
        this.courses = response.data.items;
        this.totalPages = response.data.totalPages || 1;
      } catch (error) {
        console.error("خطأ أثناء جلب الدورات:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب الدورات",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    // تنفيذ البحث
    searchCourses() {
      this.pageNumber = 1;
      this.getCoursesByFilter();
    },

    // الترقيم
    handlePageChange(newPage) {
      this.pageNumber = newPage;
      this.getCoursesByFilter();
    },

    // فتح مودال التفاصيل
    async openDetailModal(courseId) {
      this.showDetailModal = true;
      this.detailCourse = null; // نعرض "جاري التحميل"

      try {
        const res = await apiClient.get("/api/Course/GetCourseById", {
          params: { id: courseId },
        });
        this.detailCourse = res.data.data;
      } catch (error) {
        console.error("خطأ في جلب تفاصيل الكورس:", error);
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "حدث خطأ أثناء جلب تفاصيل الكورس",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    closeDetailModal() {
      this.showDetailModal = false;
      this.detailCourse = null;
    },

    // فتح مودال الإضافة
    openModalForAdd() {
      this.resetForm();
      this.isEditMode = false;
      this.showModal = true;
    },

    // فتح مودال التعديل
    openModalForEdit(course) {
      this.isEditMode = true;
      this.form.id = course.id;
      this.form.title = course.title;
      this.form.description = course.description;
      this.form.point = course.point;
      this.form.courseType = course.courseType;
      this.form.universityId = course.universityId;
      this.form.coverPhotoUrl = course.coverPhotoUrl || "";
      this.form.academicLevel = course.academicLevel;
      this.form.categoryId = course.categoryId;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.resetForm();
    },

    handleFileChange(e) {
      const file = e.target.files[0];
      this.form.coverPhoto = file;
    },
    resetForm() {
      this.isEditMode = false;
      this.form = {
        id: null,
        title: "",
        description: "",
        point: 0,
        courseType: 1,
        universityId: 0,
        coverPhoto: null,
        coverPhotoUrl: "",
        academicLevel: 1,
        categoryId: 0,
      };
      if (this.$refs.coverPhotoInput) {
        this.$refs.coverPhotoInput.value = "";
      }
    },

    // إضافة/تعديل
    async handleSubmit() {
  try {
    const formData = new FormData();
    formData.append("Title", this.form.title);
    formData.append("Description", this.form.description);
    formData.append("Point", this.form.point);
    formData.append("CourseType", this.form.courseType);
    formData.append("UniversityId", this.form.universityId);
    formData.append("AcademicLevel", this.form.academicLevel);
    formData.append("CategoryId", this.form.categoryId);
    
    if (this.form.coverPhoto) {
      formData.append("CoverPhoto", this.form.coverPhoto);
    }

    if (!this.isEditMode) {
      // إضافة دورة جديدة
      const res = await apiClient.post("/api/Course/AddCourse", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      Swal.fire({
        icon: "success",
        title: "تم",
        text: res.data.message || "تم إضافة الدورة بنجاح",
        timer: 2000,
        showConfirmButton: false,
      });
    } else {
      // تعديل الدورة
      formData.append("id", this.form.id); // أضف الـ ID إلى FormData

      const res = await apiClient.put("/api/Course/UpdateCourse", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        params: { id: this.form.id }, // إذا كان API يقبل `id` كـ param
      });

      Swal.fire({
        icon: "success",
        title: "تم",
        text: res.data.message || "تم تحديث الدورة بنجاح",
        timer: 2000,
        showConfirmButton: false,
      });
    }

    this.closeModal();
    this.getCoursesByFilter();
  } catch (error) {
    console.error("حدث خطأ أثناء حفظ الدورة:", error);
    Swal.fire({
      icon: "error",
      title: "خطأ",
      text: "حدث خطأ أثناء حفظ الدورة",
      timer: 3000,
      showConfirmButton: false,
    });
  }
},


    // حذف
    async deleteCourse(courseId) {
      const result = await Swal.fire({
        title: "تأكيد الحذف",
        text: "هل أنت متأكد من حذف هذه الدورة؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "نعم، احذفها",
        cancelButtonText: "إلغاء",
      });

      if (result.isConfirmed) {
        try {
          const res = await apiClient.delete("/api/Course/DeleteCourse", {
            params: { id: courseId },
          });
          Swal.fire({
            icon: "success",
            title: "تم الحذف",
            text: res.data.message || "تم حذف الدورة بنجاح",
            timer: 2000,
            showConfirmButton: false,
          });
          this.getCoursesByFilter();
        } catch (error) {
          console.error("خطأ أثناء حذف الدورة:", error);
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text: "حدث خطأ أثناء حذف الدورة",
            timer: 3000,
            showConfirmButton: false,
          });
        }
      }
    },

    // عرض النص المناسب للمستوى
    academicLevelText(level) {
      const map = {
        1: "الأول",
        2: "الثاني",
        3: "الثالث",
        4: "الرابع",
        5: "الخامس",
        6: "السادس",
      };
      return map[level] || `مستوى (${level})`;
    },
    handleImageError(event) {
      // منع الحلقة اللانهائية - إذا كانت الصورة بالفعل هي defaultCoverPhoto، لا تفعل شيء
      if (event.target.src === this.defaultCoverPhoto || event.target.dataset.errorHandled === 'true') {
        event.target.style.display = 'none'; // إخفاء الصورة بدلاً من إعادة المحاولة
        event.target.onerror = null; // إزالة event handler لمنع إعادة المحاولة
        return;
      }
      // تعيين علامة لمنع إعادة المحاولة
      event.target.dataset.errorHandled = 'true';
      event.target.src = this.defaultCoverPhoto;
    },
  },

  async mounted() {
    // جلب التصنيفات والجامعات
    await this.fetchCategoriesAndUniversities();
    // جلب الدورات بالفلترة
    this.getCoursesByFilter();
  },
};
</script>

<style scoped>
.course-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Header Section */
.header {
  text-align: center;
  margin-bottom: 3rem;
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: slideDown 0.5s ease-out;
}

.page-title {
  font-size: 1.0rem;
  color: #2d3748;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

/* Search Section */
.search-section {
  background: white;
  border-radius: 1rem;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  animation: fadeIn 0.5s ease-out;
}

.search-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  align-items: end;
}

.search-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.search-group label {
  font-weight: 400;
  color: #4a5568;
}

.btn-search {
  background: #4299e1;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

}

.btn-search:hover {
  background: #3182ce;
  transform: translateY(-1px);
}

/* Cards Grid */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.course-card {
  background: white;
  border-radius: 1rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
}

.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}

.cover-photo {
  width: 100%;
  height: 200px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.course-card:hover .cover-photo {
  transform: scale(1.05);
}

.card-content {
  padding: 1.5rem;
}

.course-title {
    font-size: 1.0rem;
    color: #2d3748;
    margin-bottom: 0.5rem;
    font-weight: 400;
}

.course-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: #4a5568;
  font-size: 0.875rem;
}

.course-description {
  color: #718096;
  font-size: 0.875rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.card-actions {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  border-top: 1px solid #e2e8f0;
}

.btn-edit-card, .btn-delete-card {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-edit-card {
  background: #faf089;
  color: #744210;
}

.btn-edit-card:hover {
  background: #f6e05e;
}

.btn-delete-card {
  background: #fed7d7;
  color: #c53030;
}

.btn-delete-card:hover {
  background: #feb2b2;
}

/* Modal Styles */
.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  backdrop-filter: blur(4px);
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background: white;
  border-radius: 1rem;
  width: 90%;
  max-width: 800px;
  max-height: 90vh;
  overflow-y: auto;
  padding: 2rem;
  position: relative;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
  animation: modalSlideIn 0.3s ease-out;
}

.modal-title {
  text-align: center;
  color: #2d3748;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
}

/* Form Styles */
.form-group {
  margin-bottom: 1.5rem;
}

.two-column-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.form-label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.2);
  outline: none;
}

/* Detail Modal */
.detail-modal {
  max-width: 900px;
}

.detail-scrollable {
  margin: -1rem;
  padding: 1rem;
}

.detail-cover {
  border-radius: 0.5rem;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.detail-cover-photo {
  width: 100%;
  height: auto;
  border-radius: 0.5rem;
}

.detail-content {
  background: #f8fafc;
  border-radius: 0.5rem;
  padding: 1.5rem;
}

.videos-section {
  margin-top: 1.5rem;
  background: white;
  border-radius: 0.5rem;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.videos-section h4 {
  color: #2d3748;
  margin-bottom: 1rem;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-active {
  background: #c6f6d5;
  color: #22543d;
}

.status-pending {
  background: #fefcbf;
  color: #744210;
}

.status-expired {
  background: #fed7d7;
  color: #822727;
}

/* Animations */
@keyframes slideDown {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes modalSlideIn {
  from {
    transform: translateY(-1rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-fields {
    grid-template-columns: 1fr;
  }

  .two-column-row {
    grid-template-columns: 1fr;
  }

  .cards-grid {
    grid-template-columns: 1fr;
  }

  .modal-content {
    padding: 1.5rem;
  }
}

/* RTL Specific */
[dir="rtl"] .form-control {
  text-align: right;
}

[dir="rtl"] .card-actions {
  flex-direction: row-reverse;
}

[dir="rtl"] .search-icon {
  left: 0.75rem;
  right: auto;
}
</style>
